export default __webpack_public_path__ + "static/media/john-wayne-gacy.6a9ddd3a.jpg";